import { NavLink, useNavigate } from 'react-router-dom';
import { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import {
  handleOpenMachineController,
  selectEssSwitch,
} from 'shared/slice/essSwitchSlice';
import {
  selectTesSwitch,
  tesHandleOpenMachineController,
} from 'shared/slice/tesSwitchSlice';
import {
  selectTgsSwitch,
  tgsHandleOpenMachineController,
} from 'shared/slice/tgsSwitchSlice';
import {
  alignItemsFlexStart,
  flexBoxCenter,
  flexDirectionColumn,
  justifyContentFlexStart,
  justifyContentSpaceBetween,
  layerA180Deg,
  layerADark,
  layerADisabled180Deg,
  layerB,
  layerC,
} from 'shared/styles/commonStyles';
import {
  handleEssInitialState,
  handleOpenLocation,
  handleOpenSpecificLocation,
  handleTesInitialState,
  handleTgsInitialState,
} from 'shared/slice/MCIsExpandedSlice';
import { GeneralContext } from 'shared/context/contextOfGeneral';
import { useCheckControlPermsission, useLocations } from 'shared/hooks';
import updateSelectionHash from 'shared/helpers/ess-tgs-tes-mc/updateSelectionHash';
import {
  filterFlatSwitchTree,
  filterSwitchTree,
} from 'shared/helpers/filterSwitchTree';

const SearchBox = ({ handleClose, isMobile }) => {
  const switchButtonNames = ['ess', 'tgs', 'tes'];
  const links = ['/ess', '/tgs', '/tes'];
  const initialButtonState = [false, false, false];
  const [isSelected, setIsSelected] = useState(initialButtonState);
  const [selectedSwitch, setSelectedSwitch] = useState(null);

  const locations = useLocations();
  const { essSwitch, flatEssSwitch } = useSelector(selectEssSwitch);
  const { tgsSwitch, flatTgsSwitch } = useSelector(selectTgsSwitch);
  const { tesSwitch, flatTesSwitch } = useSelector(selectTesSwitch);

  const switches =
    selectedSwitch && selectedSwitch === 'ess'
      ? filterSwitchTree(essSwitch, 'ess')
      : selectedSwitch === 'tgs'
      ? filterSwitchTree(tgsSwitch, 'tgs')
      : selectedSwitch === 'tes'
      ? filterSwitchTree(tesSwitch, 'tes')
      : {};
  const flatSwitches =
    selectedSwitch && selectedSwitch === 'ess'
      ? filterFlatSwitchTree(flatEssSwitch, 'ess')
      : selectedSwitch === 'tgs'
      ? filterFlatSwitchTree(flatTgsSwitch, 'tgs')
      : selectedSwitch === 'tes'
      ? filterFlatSwitchTree(flatTesSwitch, 'tes')
      : {};























  const dispatch = useDispatch();
  const navigate = useNavigate();


  const { handleOnClick } = useContext(GeneralContext);

  const handleSelectSwitch = (id) => {
    const arr = [...initialButtonState];
    arr[id] = true;
    setIsSelected(arr);
    setSelectedSwitch(switchButtonNames[id]);
    handleOnClick('groupD', id);
  };

  const machineControlHandler = (
    dispatchInitialStateFC,
    dispatchOpenMachineFC,
    swtName,
    location,
    locationIdx,
    el,
    elIdx,
    machine
  ) => {
    const locationArr = Object.keys(switches).map((location) => false);
    dispatch(dispatchInitialStateFC(locationArr));

    Object.keys(flatSwitches).forEach((location) =>
      Object.keys(flatSwitches[location]).forEach((newMachine) => {
        dispatch(
          dispatchOpenMachineFC({
            location,
            machine: newMachine,
            status: false,
          })
        );
      })
    );

    if (machine) {
      const targetLocation = el;
      dispatch(
        handleOpenLocation({
          swtName,
          index: locationIdx,
          status: true,
        })
      );
      dispatch(
        handleOpenSpecificLocation({
          swtName,
          openSpecificLocationIdx: elIdx,
          status: true,
        })
      );

      dispatch(
        dispatchOpenMachineFC({
          location: targetLocation,
          machine,
          status: true,
        })
      );
    } else {
      dispatch(
        handleOpenLocation({
          swtName,
          index: locationIdx,
          status: true,
        })
      );
      dispatch(
        dispatchOpenMachineFC({
          location,
          machine: el,
          status: true,
        })
      );
    }
  };

  const handleGoTo = (location, locationIndex, el, elIdx, machine) => {
    const isSpecificLocation = Boolean(machine);
    const flatLocation = isSpecificLocation ? el : location;
    const flatMachine = isSpecificLocation ? machine : el;
    const specificLocation = isSpecificLocation ? el : '';
    const hash = new URLSearchParams({
      location,
      ...(specificLocation && { specificLocation }),
    }).toString();
    const swtLink = links[switchButtonNames.indexOf(selectedSwitch)];
    if (swtLink) {
      navigate(
        `${swtLink}?switch=${encodeURIComponent(
          `${flatLocation} - ${flatMachine}`
        )}#${hash}`
      );
    }

    updateSelectionHash({ location, specificLocation });
    sessionStorage.setItem('locationId', location);
    if (specificLocation) {
      sessionStorage.setItem('specificLocationId', specificLocation);
    } else {
      sessionStorage.removeItem('specificLocationId');
    }

    if (selectedSwitch === 'ess') {
      machineControlHandler(
        handleEssInitialState,
        handleOpenMachineController,
        'ess',
        location,
        locationIndex,
        el,
        elIdx,
        machine
      );























    } else if (selectedSwitch === 'tgs') {
      machineControlHandler(
        handleTgsInitialState,
        tgsHandleOpenMachineController,
        'tgs',
        location,
        locationIndex,
        el,
        elIdx,
        machine
      );

























    } else if (selectedSwitch === 'tes') {
      machineControlHandler(
        handleTesInitialState,
        tesHandleOpenMachineController,
        'tes',
        location,
        locationIndex,
        el,
        elIdx,
        machine
      );

























    }
    handleClose();
  };

  const selectListDisplay = Object.keys(switches).map(
    (location, locationIndex) =>
      switches[location]?.isSpecificLocation
        ? Object.keys(switches[location].subLocations || {}).map((el, elIdx) =>
            Object.keys(switches[location].subLocations[el].devices || {}).map(
              (machine, machineIdx) => {
                const machineData = locations.all[el];
                const formattedName = `${machineData?.locationName} - ${machineData?.specificLocationName} -
              ${machineData?.devices[machine]?.machineName} -
              ${flatSwitches[el]?.[machine]?.heatingSystem}`;
                return (
                  <SwitchSelectWrapper
                    key={`${selectedSwitch}-${location}-${el}-${machine}`}
                    isMobile={isMobile}
                  >
                    <DotAndTitleWrapper isMobile={isMobile}>
                      <GreenDot />
                      <SwitchName isMobile={isMobile}>{formattedName}</SwitchName>
                    </DotAndTitleWrapper>
                    <GoToButton
                      isMobile={isMobile}
                      onClick={() =>
                        handleGoTo(
                          location,
                          locationIndex,
                          el,
                          elIdx,
                          machine,
                          machineIdx
                        )
                      }
                    >
                      go to
                    </GoToButton>
                  </SwitchSelectWrapper>
                );
              }
            )
          )
        : Object.keys(switches[location].devices || {}).map((el) => {
          const machineData = locations.all[location];
          const formattedName = `${machineData.locationName} -
          ${machineData.devices[el]?.machineName} -
          ${flatSwitches[location]?.[el]?.heatingSystem}`;
          return (
            <SwitchSelectWrapper
              key={`${selectedSwitch}-${location}-${el}`}
              isMobile={isMobile}
            >
              <DotAndTitleWrapper isMobile={isMobile}>
                <GreenDot />
                <SwitchName isMobile={isMobile}>

                  {formattedName}
                </SwitchName>
              </DotAndTitleWrapper>
              <GoToButton
                isMobile={isMobile}
                onClick={() => handleGoTo(location, locationIndex, el)}
              >
                go to
              </GoToButton>
            </SwitchSelectWrapper>
          );
        })
  );

  const checkControlPermsission = useCheckControlPermsission();
  return (
    <Wrapper selectedSwitch={selectedSwitch} isMobile={isMobile}>
      <SectionHeaderButton isMobile={isMobile}>
        {switchButtonNames.map((swt, index) => {
          const isDisabled = !checkControlPermsission(swt);
          return (
            <NavLinkButton to={links[index]} key={Math.random() * 10000}>
              <SwitchButton
                isMobile={isMobile}
                disabled={isDisabled}
                isSelected={isSelected[index]}
                onClick={() => isDisabled || handleSelectSwitch(index)}
              >
                {swt}
              </SwitchButton>
            </NavLinkButton>
          );
        })}
      </SectionHeaderButton>
      {selectedSwitch && (
        <ScrollWrapper isMobile={isMobile}>
          <SectionSwitches isMobile={isMobile}>

            {selectListDisplay}
          </SectionSwitches>
        </ScrollWrapper>
      )}
    </Wrapper>
  );
};
export default SearchBox;

const Wrapper = styled.div`
  width: 100%;
  ${flexDirectionColumn};
  gap: 4px;
  padding: 2px 0 4px 0;
  ${(p) =>
    p.selectedSwitch &&
    css`
      height: auto;
    `}

  ${(p) => p.isMobile && css``}
`;

const SectionHeaderButton = styled.section`
  width: 510px;
  height: 36px;
  border-radius: 18px;
  ${layerADark};
  ${justifyContentSpaceBetween};
  padding: 0 1px;

  ${(p) =>
    p.isMobile &&
    css`
      width: 319px;
      height: 36px;
      ${layerADark}
      padding: 1px  4px 0 4px;
    `}
`;
const NavLinkButton = styled(NavLink)``;
const SwitchButton = styled.button`
  width: 124px;
  height: 34px;
  border-radius: 25px;
  font-size: 14px;
  letter-spacing: 1.4px;

  ${layerA180Deg};

  ${(p) =>
    p.isSelected &&
    css`
      border: 1px solid #95ff45;
    `}

  ${(p) =>
    p.disabled &&
    css`
      ${layerADisabled180Deg}
      border: 1px solid #000000;
      cursor: not-allowed;
    `}

    ${(p) =>
    p.isMobile &&
    css`
      width: 74px;
      height: 28px;
    `}
`;

const ScrollWrapper = styled.div`
  width: 514px;

  min-height: 36px;

  border-radius: 18px 8px 8px 18px;

  ${layerC};
  ${flexBoxCenter};
  padding: 4px;
  ${(p) =>
    p.isMobile &&
    css`
      width: 319px;
      height: 141px;
      border-radius: 18px;
      ${layerC};
      ${alignItemsFlexStart}
      ::-webkit-scrollbar {
        display: none;
      }
    `}
`;
const SectionSwitches = styled.section`
  width: 100%;
  min-height: 36px;
  max-height: 144px;
  ${flexDirectionColumn}


  scroll-behavior: smooth;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 10px;
    border: 1px solid #ffffff;
    border-radius: 13px;
  }
  ::-webkit-scrollbar-track {
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 13px;
    border: 1.5px solid transparent;
    background-clip: padding-box;
    height: 40%;
  }

  ::-webkit-scrollbar-button:start:decrement {
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
    height: 10px;

    background-image: url('/images/scrollbar-button-start.svg');
  }
  ::-webkit-scrollbar-button:end:increment {
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
    height: 10px;

    background-image: url('/images/scrollbar-button-end.svg');
  }

  ${(p) =>
    p.isMobile &&
    css`
      max-height: 138px;
      ::-webkit-scrollbar {
        display: none;
      }
    `}
`;
const SwitchSelectWrapper = styled.div`
  width: 491px;
  height: 30px;
  border: 1px solid #233a54;
  border-radius: 16px;
  padding: 0 0 0 10px;

  margin-bottom: 3px;
  &:last-child {
    margin-bottom: 0;
  }

  ${justifyContentSpaceBetween}

  &:hover {
    ${layerB}
  }

  ${(p) =>
    p.isMobile &&
    css`
      width: 310px;
      min-height: 32px;
    `}
`;
const DotAndTitleWrapper = styled.div`
  ${justifyContentFlexStart}

  ${(p) =>
    p.isMobile &&
    css`
      width: 70%;
    `}
`;

const GreenDot = styled.div`
  min-width: 12px;
  max-height: 12px;
  height: 12px;
  border-radius: 50%;
  background: #95ff45;
  margin-right: 10px;
`;

const SwitchName = styled.span`
  ${(p) =>
    p.isMobile
      ? css`
          font-size: 8px;
        `
      : css`
          font-size: 10px;
          width: 320px;
        `}
`;
const GoToButton = styled.button`
  width: 118px;
  height: 28px;
  border-radius: 25px;
  font-size: 16px;
  letter-spacing: 1.6px;
  ${layerA180Deg}

  ${(p) =>
    p.isSelected &&
    css`
      border: 1px solid #233a54;
    `}

    ${(p) =>
    p.isMobile &&
    css`
      width: 83px;
      height: 28px;
    `}
`;
